<template lang="pug">
  b-card
    b-overlay(:show="updating", variant="transparent", spinner-variant="primary")
      b-form-row.mb-3
        b-col(md="6")
          b-form-group(label-size="sm" )
            template(#label)
              .d-flex.justify-content-between.align-items-center
                label.mb-0 Nombre
                trash-2-icon.icon-md.hover-danger.pointer.text-secondary(@click="destroyFilter()" )
            b-form-input(size="sm", placeholder="Nombre", v-model="filter.title", @update="updateDebounce()")
        b-col.mb-2(md="6")
          b-form-group(label="Operador", label-size="sm" )
            b-form-select(size="sm", placeholder="Operador", :options="operators" v-model="filter.operator", @change="updateFilter(filter)")
        b-col(cols="12")
          b-form-group(label="Propiedades" label-size="sm" )
            b-input-group.mb-2(size="sm" v-for="(prop, index) in filter.properties", :key="index")
              b-input-group-prepend(v-if="prop.property.title")
                b-input-group-text {{prop.property.title}}
              b-form-input(placeholder="Valor",
                :list="prop._id",
                v-model="prop.value",
                @update="updateDebounce()"
              )
              b-input-group-prepend
                b-button(variant="soft-danger", size="sm", @click="removeProperty(index)")
                  trash-2-icon.icon-sm
              datalist(:id="prop._id", v-if="prop.property && prop.property.defaults")
                option(v-for="propOption in prop.property.defaults", :key="propOption") {{propOption}}
      b-form-row
        b-col()
          b-form-select(size="sm", :options="properties" v-model="newProperty.property")
            template(#first)
              b-form-select-option(:value="null", disabled) Tipo de propiedad
        b-col()
          b-form-input(autocomplete="off", size="sm", list="newPropertyValue", placeholder="Valor", v-model="newProperty.value")
          datalist#newPropertyValue(v-if="selectedProperty && selectedProperty.defaults")
            option(v-for="defaultOption in selectedProperty.defaults", :key="defaultOption") {{defaultOption}}
        b-col(cols="auto")
          b-button(variant="success", size="sm", :disabled="!canAdd", @click="addProperty()") Agregar
</template>

<script>
import {createNamespacedHelpers, mapActions} from 'vuex'
import {debounce} from 'lodash'
import threeSelectOptions from '@/data/treeselect-options'
const propertyController = createNamespacedHelpers('property')

export default {
  name: 'PropertyFilter',
  data () {
    return {
      updating: false,
      operators: ['and', 'or'],
      newProperty: {
        value: '',
        property: null,
      },
      threeSelectOptions
    }
  },
  props: {
    filter:{
      type: Object,
      default: () => {
        return {
          _id: '',
          title: '',
          operator: '',
          properties: []
        }
      }
    }
  },
  computed: {
    ...propertyController.mapState({
      properties: state => state.properties.map(el => {
        return {
          text: el.title,
          value: el._id,
          ...el
        }
      })
    }),
    canAdd() {
      return !!(this.newProperty.value && this.newProperty.property)
    },
    selectedProperty() {
      if(!this.newProperty.property) return null
      return this.properties.find(({_id}) => _id === this.newProperty.property)
    }
  },
  methods: {
    ...mapActions([
      'property_filter/update',
      'property_filter/destroy',
    ]),
    updateDebounce: debounce(function () {
      this.updateFilter()
    }, 500, {leading: false, trailing: true}),
    addProperty() {
      this.filter.properties.push(this.newProperty)
      this.updateFilter()
    },
    removeProperty(index) {
      this.filter.properties.splice(index, 1)
      this.updateFilter()
    },
    updateFilter() {
      this.updating = true
      if(!this.filter.title) return

      this['property_filter/update']({
        ...this.filter,
        callback: res => {
          this.updating = false
          if (res.error) return this.$message.error(res.error)
          this.filter.properties = res.resource.properties.slice()
        }
      })
    },
    destroyFilter(){
      this.updating = true

      this['property_filter/destroy']({
        ...this.filter,
        callback: res => {
          this.updating = false
          if (res.error) return this.$message.error(res.error)
        }
      })
    }
  },
  mounted () {

  }
}
</script>

<style scoped>

</style>